import {Component, Inject, OnInit} from '@angular/core';
import {CssPropertiesEnum} from '../../core/models/css-properties.enum';
import {TranslationService} from '../../core/services/translation.service';
import {VHostService} from '../../core/services/v-host.service';
import {OfferGroup} from '../../data/models/offer-group.model';
import {OfferService} from '../../data/services/offer.service';
import {NavigationCommand, NavigationService} from '../../data/services/navigation.service';
import {DOCUMENT} from '@angular/common';
import {ExternalOffer} from '../../data/models/external-offer.model';
import {ExternalOfferService} from '../../core/services/external-offer.service';
import {ImageService} from '../../core/services/image.service';
import {LandingPage} from '../../data/models/landing-page.model';
import {LandingPageService} from '../../data/services/landing-page.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ImageHandler} from "../../image-handler.service";

@Component({
  selector: 'app-offer-group',
  templateUrl: './offer-group.component.html',
  styleUrls: ['./offer-group.component.css']
})
export class OfferGroupComponent implements OnInit {

  CssPropertiesEnum = CssPropertiesEnum;
  isLoadingOfferGroup: boolean = false;
  errorsArr: string[] = [];
  offerGroups: OfferGroup[] = [];
  cssPropertiesEnum = CssPropertiesEnum;
  actualPage: LandingPage;
  public externalOffersForSlider: ExternalOffer[] = [];
  private titlesAllowed: string[] = []

  constructor(
    public translationService: TranslationService,
    public vHostService: VHostService,
    private offerService: OfferService,
    private navigationService: NavigationService,
    public externalOfferService: ExternalOfferService,
    public imageService: ImageService,
    @Inject(DOCUMENT) private document: Document,
    private imageHandler: ImageHandler,
    private landingPageService: LandingPageService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.route?.queryParamMap?.subscribe(paramMap => {
      if (paramMap?.get('titlesAllowed')) {
        this.titlesAllowed = paramMap?.get('titlesAllowed').split(',');
      }
    });

    this.isLoadingOfferGroup = true;
    this.offerService.getOfferGroups().subscribe({
      next: offerGroups => {
        this.offerGroups = offerGroups;
        if (offerGroups.length == 1 && this.titlesAllowed.length <= 0) {
          this.goToOfferModule(offerGroups[0].rId, 0);
        } else {
          this.offerService.getMinimalOffers(true).subscribe({
            next: offers => {
              offerGroups.forEach(group => {
                if (group.activeFlag) {
                  group.hasOffers = offers.some(offer => (offer.offerGroup === group.rId) && (this.titlesAllowed?.length <= 0 || this.titlesAllowed?.includes(offer['productCode'])));
                } else {
                  group.hasOffers = false;
                }
                if (!group.hasOffers) {
                  console.log('No offers for groupId ' + group.rId);
                }
              });
              this.isLoadingOfferGroup = false;
            },
            error: () => {
              this.errorsArr.push(this.translationService.getTranslation('error_offerGroup_init'));
            }
          });
        }
      },
      error: () => {
        this.errorsArr.push(this.translationService.getTranslation('error_offer_init'));
      }
    });
  }

  ngOnInit(): void {
    this.externalOfferService.loadExternalOffersForSlider().subscribe({
       next: (externalOffers: ExternalOffer[]) => {
         if (externalOffers) {
           this.externalOffersForSlider = externalOffers;
           this.externalOffersForSlider.forEach(e => {
             this.imageService.getImageOfExternalOffer(e.id).subscribe(image => {
               if (image && image.type) {
                 e.image = this.imageHandler.addAltText(image, e.description ?? this.translationService.getTranslation('externalOffer.image.altText.default'));
                 if (!e.image) {
                   externalOffers.splice(externalOffers.indexOf(e));
                 }
               }
             });
           });
         }
       },
       error: err => console.error('Couldn´t find ExternalOffer for Slider', err),
    });

    this.landingPageService.getPageOfUrl(this.router.url.split('/')[1]).subscribe( page => {
      if (page) {
        this.actualPage = page;
      }
    });
  }

  goToOfferModule(offerGroup, moreThanOneGroup): void {
    this.navigationService.navigateTo(NavigationCommand.OFFERLIST, [offerGroup, moreThanOneGroup]);
  }

}
